import {lazy, Suspense} from "react";
// components
import LoadingScreen from "../components/loading-screen";
// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
    (
        <Suspense fallback={<LoadingScreen/>}>
            <Component {...props} />
        </Suspense>
    );

// ----------------------------------------------------------------------

// AUTHENTICATION
export const Login = Loadable(lazy(() => import("../pages/auth/LoginPage")));

// PAGES
export const HomePage = Loadable(lazy(() => import("../pages/Home")));
export const StationServicesPage = Loadable(lazy(() => import("../pages/StationServices")));
export const ReportsPage = Loadable(lazy(() => import("../pages/ReportNew")));
export const AdditionalIncomePage = Loadable(lazy(() => import("../pages/ReportNew/AdditionalIncomeReport")));
export const OverviewTicketAndOtherPage = Loadable(lazy(() => import("../pages/ReportNew/OverviewTicketAndOther")));
export const ValidatedTicketReportPage = Loadable(lazy(() => import("../pages/ValidatedTicketReport")));
export const InvoicePage = Loadable(lazy(() => import("../pages/Invoices")));
export const BusTickets = Loadable(lazy(() => import("../pages/BusTickets")));

// ITEMS
export const ItemsPage = Loadable(lazy(() => import("../pages/Items")));
export const ItemsNewPage = Loadable(lazy(() => import("../pages/Items/ItemsNew")));
export const ItemsEditPage = Loadable(lazy(() => import("../pages/Items/ItemsEdit")));
export const RateCardItemsPage = Loadable(lazy(() => import("../pages/Items/RateCardItems")));

// DISCOUNTS
// ZA SVE
export const DiscountsList = Loadable(lazy(() => import("../pages/Discounts/DiscountsGlobal")));
export const DiscountsNew = Loadable(lazy(() => import("../pages/Discounts/DiscountsGlobal/DiscountsNew")));
export const DiscountsEditPage = Loadable(lazy(() => import("../pages/Discounts/DiscountsGlobal/DiscountEditPage")));


// TRIP SEAT STATUS
export const TripSeatStatus = Loadable(lazy(() => import("../pages/TripSeatStatus")));


// DISABILITIES

export const DisabilitiesList = Loadable(lazy(() => import("../pages/Disability")));
export const DisabilityNew = Loadable(lazy(() => import("../pages/Disability/DisabilityNew")));
export const DisabilityEditPage = Loadable(lazy(() => import("../pages/Disability/DisabilityEditPage")));


// PRIVILAGES

export const PrivilegesList = Loadable(lazy(() => import("../pages/Privileges")));
export const PrivilegesNew = Loadable(lazy(() => import("../pages/Privileges/PrivilegesNew")));
export const PrivilegesEditPage = Loadable(lazy(() => import("../pages/Privileges/PrivilegesEditPage")));

// BUS
export const DispatchDepots = Loadable(lazy(() => import("../pages/DispatchCenter/Depots")));
export const DispatchDrivers = Loadable(lazy(() => import("../pages/DispatchCenter/Drivers")));
export const DispatchDriverNew = Loadable(lazy(() => import("../pages/DispatchCenter/Drivers/DriverNew")));
export const DispatchDriverEdit = Loadable(lazy(() => import("../pages/DispatchCenter/Drivers/DriverEditPage")));
export const DispatchScheduleWeek = Loadable(lazy(() => import("../pages/DispatchCenter/Schedule/Week")));
export const DispatchUnassigned = Loadable(lazy(() => import("../pages/DispatchCenter/Schedule/Unassigned")));
export const DispatchTurnusList = Loadable(lazy(() => import("../pages/DispatchCenter/Turnus")));
export const DispatchTurnusNew = Loadable(lazy(() => import("../pages/DispatchCenter/Turnus/TurnusNew")));
export const DispatchTurnusEdit = Loadable(lazy(() => import("../pages/DispatchCenter/Turnus/TurnusEditPage")));
export const DispatchScheduleDay = Loadable(lazy(() => import("../pages/DispatchCenter/Schedule/Day")));
export const DispatchTurnusSchedule = Loadable(lazy(() => import("../pages/DispatchCenter/Schedule/TurnusSchedule")));
export const DispatchDriverReport = Loadable(lazy(() => import("../pages/DispatchCenter/Reports/DriverReport")));
export const DispatchTravelOrders = Loadable(lazy(() => import("../pages/DispatchCenter/TravelOrders")));
export const DispatchFleet = Loadable(lazy(() => import("../pages/DispatchCenter/Fleet")));
export const DispatchFleetHistory = Loadable(lazy(() => import("../pages/DispatchCenter/Fleet/History")));
export const CityLines = Loadable(lazy(() => import("../pages/CityTransport/Lines")));
export const CityLineNew = Loadable(lazy(() => import("../pages/CityTransport/Lines/CityLineNew")));
export const CityLineEdit = Loadable(lazy(() => import("../pages/CityTransport/Lines/CityLineEditPage")));
export const CityZones = Loadable(lazy(() => import("../pages/CityTransport/Zones")));
export const CityExceptions = Loadable(lazy(() => import("../pages/CityTransport/Exceptions")));
export const CityDepartures = Loadable(lazy(() => import("../pages/CityTransport/Departures")));
export const CityFares = Loadable(lazy(() => import("../pages/CityTransport/Fares")));
export const CityPasses = Loadable(lazy(() => import("../pages/CityTransport/Passes")));
export const CitySale = Loadable(lazy(() => import("../pages/CityTransport/Sale")));
export const CityCards = Loadable(lazy(() => import("../pages/CityTransport/Cards")));
export const CityReports = Loadable(lazy(() => import("../pages/CityTransport/Reports")));
export const CityKmReport = Loadable(lazy(() => import("../pages/CityTransport/Reports/Kilometers")));
export const CityTickets = Loadable(lazy(() => import("../pages/CityTransport/Tickets")));
export const CityVehicleReport = Loadable(lazy(() => import("../pages/CityTransport/Reports/Vehicles")));
export const CityDeviceReport = Loadable(lazy(() => import("../pages/CityTransport/Reports/Devices")));
export const CityFinanceReport = Loadable(lazy(() => import("../pages/CityTransport/Reports/Finance")));
export const CityInspectorReport = Loadable(lazy(() => import("../pages/CityTransport/Reports/Inspectors")));
export const CityTimetable = Loadable(lazy(() => import("../pages/CityTransport/Lines/Timetable")));
export const CityInvoices = Loadable(lazy(() => import("../pages/CityTransport/Invoices")));
export const CityValidations = Loadable(lazy(() => import("../pages/CityTransport/Validations")));
export const CityRoutes = Loadable(lazy(() => import("../pages/CityTransport/Routes")));
export const CityAccountPasses = Loadable(lazy(() => import("../pages/CityTransport/Reports/AccountPasses")));
export const CityDriverSettlement = Loadable(lazy(() => import("../pages/CityTransport/DriverSettlement")));
export const CityRoutePlan = Loadable(lazy(() => import("../pages/CityTransport/Routes/RoutePlan")));
export const BusList = Loadable(lazy(() => import("../pages/Bus")));
export const BusNew = Loadable(lazy(() => import("../pages/Bus/BusNew")));
export const BusEditPage = Loadable(lazy(() => import("../pages/Bus/BusEditPage")));

// PHOLIDAYS
export const HolidaysList = Loadable(lazy(() => import("../pages/Holidays")));
export const HolidaysNew = Loadable(lazy(() => import("../pages/Holidays/HolidaysNew")));
export const HolidaysEditPage = Loadable(lazy(() => import("../pages/Holidays/HolidaysEditPage")));

// PRICE LIST
export const PriceList = Loadable(lazy(() => import("../pages/PriceList")));
export const LinkPriceListTripPage = Loadable(lazy(() => import("../pages/PriceList/LinkPriceListTrip")));
export const PriceStationsList = Loadable(lazy(() => import("../pages/PriceList/PriceStationsList")));
export const PriceListNew = Loadable(lazy(() => import("../pages/PriceList/PriceListNew")));
export const PriceListStationNew = Loadable(lazy(() => import("../pages/PriceList/PriceStationsList/PriceListStationNew")));
export const PriceListEditPage = Loadable(lazy(() => import("../pages/PriceList/PriceListEditPage")));
export const PriceListStationEditPage = Loadable(lazy(() => import("../pages/PriceList/PriceStationsList/PriceListStationEditPage")));
export const InstantPage = Loadable(lazy(() => import("../pages/PriceList/InstantPage")));

// STATION LIST
export const StationList = Loadable(lazy(() => import("../pages/Stations")));
export const StationListNew = Loadable(lazy(() => import("../pages/Stations/StationListNew")));
export const StationListEditPage = Loadable(lazy(() => import("../pages/Stations/StationListEditPage")));

// LOCATIONS LIST
export const LocationsList = Loadable(lazy(() => import("../pages/Locations")));
export const LocationsListNew = Loadable(lazy(() => import("../pages/Locations/LocationsListNew")));
export const LocationsListEditPage = Loadable(lazy(() => import("../pages/Locations/LocationsListEditPage")));

// LINES LIST
export const LinesList = Loadable(lazy(() => import("../pages/Lines")));
export const LinesListNew = Loadable(lazy(() => import("../pages/Lines/LinesListNew")));
export const LinesListEditPage = Loadable(lazy(() => import("../pages/Lines/LinesListEditPage")));

// DISABLED LINE STATIONS
export const DisabledLineStationsList = Loadable(lazy(() => import("../pages/DisabledLineStations")));
export const DisabledLineStationNew = Loadable(lazy(() => import("../pages/DisabledLineStations/DisabledLineStationNew")));

// DEPARTURES LIST
export const DeparturesList = Loadable(lazy(() => import("../pages/Departures")));
export const DeparturesListNew = Loadable(lazy(() => import("../pages/Departures/DeparturesListNew")));
export const DeparturesListEditPage = Loadable(lazy(() => import("../pages/Departures/DeparturesListEditPage")));
export const LinkedNewPage = Loadable(lazy(() => import("../pages/Departures/Linked/LinkedNewPage")));
export const LinkedEditPage = Loadable(lazy(() => import("../pages/Departures/Linked/LinkedEditPage")));
export const AttachedRateCardPage = Loadable(lazy(() => import("../pages/Departures/Linked/AttachRateCard")));
export const DeparturesLinkedListPage = Loadable(lazy(() => import("../pages/Departures/DeparturesLinkedList")));
export const DeparturesExceptionsPage = Loadable(lazy(() => import("../pages/Departures/TripStationException")));
export const BulkOperationalIntervalPage = Loadable(lazy(() => import("../pages/Departures/BulkOperationalIntervalPage")));

// ALLOTMENTS
export const AllotmentList = Loadable(lazy(() => import("../pages/Allotment")));
export const AllotmentNew = Loadable(lazy(() => import("../pages/Allotment/AllotmentNew")));
export const AllotmentEditPage = Loadable(lazy(() => import("../pages/Allotment/AllotmentEditPage")));
// export const AllotmentBoardPage = Loadable(lazy(() => import("../pages/Allotment/Board")));

// TIMES LIST
export const TimesList = Loadable(lazy(() => import("../pages/Times")));
// ACTIONS LIST
export const ActionsList = Loadable(lazy(() => import("../pages/Actions")));
export const PromoNotificationsList = Loadable(lazy(() => import("../pages/PromoNotifications")));
export const ActionsListNew = Loadable(lazy(() => import("../pages/Actions/ActionsNew")));
export const ActionsEditPage = Loadable(lazy(() => import("../pages/Actions/ActionsEditPage")));

// ACTIONS VALUES
// export const ActionsValueList = Loadable(lazy(() => import("../pages/Actions/ActionsValue")));
export const ActionsValueListNew = Loadable(lazy(() => import("../pages/Actions/ActionsValue/ActionsValueNew")));
export const ActionsValueEditPage = Loadable(lazy(() => import("../pages/Actions/ActionsValue/ActionsValueEditPage")));

// MONTHLY LIST
export const MonthlyTicketsList = Loadable(lazy(() => import("../pages/MonthlyTickets")));
export const MonthlyTicketsListNew = Loadable(lazy(() => import("../pages/MonthlyTickets/MonthlyTicketsNew")));
export const MonthlyTicketsListEditPage = Loadable(lazy(() => import("../pages/MonthlyTickets/MonthlyTicketsListEditPage")));

// CUSTOMERS
export const CustomersList = Loadable(lazy(() => import('../pages/Customers/CustomersList')))
export const CustomersNew = Loadable(lazy(() => import('../pages/Customers/CustomersNew')))
export const CustomersEditPage = Loadable(lazy(() => import('../pages/Customers/CustomersEditPage')))

// CARRIERS
export const CarriersList = Loadable(lazy(() => import('../pages/Carriers/CarriersList')))
export const CarriersNew = Loadable(lazy(() => import('../pages/Carriers/CarriersNew')))
export const CarriersEditPage = Loadable(lazy(() => import('../pages/Carriers/CarriersEditPage')))

// INSURANCE
export const InsuranceList = Loadable(lazy(() => import('../pages/Insurance/InsuranceList')))
export const InsuranceNew = Loadable(lazy(() => import('../pages/Insurance/InsuranceNew')))
export const InsuranceEditPage = Loadable(lazy(() => import('../pages/Insurance/InsuranceEditPage')))

// PLATFORMS
export const PlatformsList = Loadable(lazy(() => import('../pages/Platforms')))
export const PlatformsNew = Loadable(lazy(() => import('../pages/Platforms/PlatformsNew')))
export const PlatformsEditPage = Loadable(lazy(() => import('../pages/Platforms/PlatformsEditPage')))
export const PlatformBusynessPage = Loadable(lazy(() => import('../pages/Platforms/busyness/PlatformBusyness')))

// SERVICES
// export const ServicesList = Loadable(lazy(() => import('../pages/Services')))
// export const ServicesNew = Loadable(lazy(() => import('../pages/Services/ServiceNew')))
// export const ServicesEditPage = Loadable(lazy(() => import('../pages/Services/ServicesEditPage')))

// OTPRAVNIK
export const UnusedCameraEvents = Loadable(lazy(() => import('../pages/Optravnik/UnusedCameraEvents')))
export const TrafficLogsPage = Loadable(lazy(() => import('../pages/Optravnik/TrafficLogs')))
export const TrafficLogActionLogPage = Loadable(lazy(() => import('../pages/Optravnik/ActionLog')))
export const OtpravnikList = Loadable(lazy(() => import('../pages/Optravnik')))
export const OtpravnikNew = Loadable(lazy(() => import('../pages/Optravnik/OtpravnikNew')))
export const OtpravnikEditPage = Loadable(lazy(() => import('../pages/Optravnik/OtpravnikEditPage')))
export const PublisherPage = Loadable(lazy(() => import('../pages/Optravnik/Publisher')))
export const OtpravnikNewBIS = Loadable(lazy(() => import('../pages/Optravnik/AddNewBisVehicle')))
export const OtherOtpravnikPage = Loadable(lazy(() => import('../pages/Optravnik/Other')))

// SCHEDULED DEP AND ARR
export const ScheduledDepAndArrList = Loadable(lazy(() => import('../pages/ScheduledDepAndArr')))
export const PeronizationList = Loadable(lazy(() => import('../pages/Peronization')))
export const PeronizationNew = Loadable(lazy(() => import('../pages/Peronization/PeronizationNew')))
export const PeronizationPrice = Loadable(lazy(() => import('../pages/Peronization/PeronizationPrice')))
export const ParkingList = Loadable(lazy(() => import('../pages/Parking')))

// PARKING SERVICES
export const ParkingServicesList = Loadable(lazy(() => import('../pages/ParkingServices')))
export const ParkingServicesNew = Loadable(lazy(() => import('../pages/ParkingServices/ParkingServiceNew')))
export const ParkingServicesEditPage = Loadable(lazy(() => import('../pages/ParkingServices/ParkingServiceEdit')))

// CARRIER REPORT
export const CarrierReport = Loadable(lazy(() => import('../pages/CarrierReport')))
export const CarrierReportEdit = Loadable(lazy(() => import('../pages/CarrierReport/CarrierReportCustomTable')))
export const CarrierReportDetailed = Loadable(lazy(() => import('../pages/CarrierReport/CarrierReportDetailed')))
export const CarrierReportPrivilegesTickets = Loadable(lazy(() => import('../pages/CarrierReport/CarrierReportPrivilegesTickets')))
export const CarrierReportDiscountedTickets = Loadable(lazy(() => import('../pages/CarrierReport/CarrierReportDiscountedTickets')))
export const CarrierReportReturnTickets = Loadable(lazy(() => import('../pages/CarrierReport/CarrierReportReturnTickets')))
export const CarrierReportTickets = Loadable(lazy(() => import('../pages/CarrierReport/CarrierReportTickets')))
export const ValidatedTicketsPage = Loadable(lazy(() => import('../pages/CarrierReport/validatedTickets')))
export const AllTicketsPage = Loadable(lazy(() => import('../pages/CarrierReport/AllTickets')))
export const TicketOperatorStatsPage = Loadable(lazy(() => import('../pages/TicketOperatorStats')))
export const TicketSalesFinancialReportPage = Loadable(lazy(() => import('../pages/TicketSalesFinancialReport')))
export const FidkpReportPage = Loadable(lazy(() => import('../pages/OtherSalesChannels/FidkpReport')))
export const AnalyticsAndCommissions = Loadable(lazy(() => import('../pages/AnalyticsAndCommissions')))
export const AdditionalRevenueDetailedReportPage = Loadable(lazy(() => import('../pages/AdditionalRevenueDetailedReport')))
export const ActionsReportPage = Loadable(lazy(() => import('../pages/ActionsReport')))
export const LiquidationPage = Loadable(lazy(() => import('../pages/Liquidation')))
export const MultiPassValidationReportPage = Loadable(lazy(() => import('../pages/MultiPassValidationReport')))
export const SoldServicesPage = Loadable(lazy(() => import('../pages/SoldServices')))
export const MultiPassesByClientPage = Loadable(lazy(() => import('../pages/MultiPassesByClient')))
export const InternationalReportPage = Loadable(lazy(() => import('../pages/InternationalReport')))
export const WhiteListReportPage = Loadable(lazy(() => import('../pages/WhiteListReport')))


// OPERATORS
export const OperatorsList = Loadable(lazy(() => import("../pages/Operators")));
export const OperatorsNew = Loadable(lazy(() => import("../pages/Operators/OperatorsNew")));
export const OperatorsEditPage = Loadable(lazy(() => import("../pages/Operators/OperatorsEditPage")));

// COMMENTS
export const CommentsList = Loadable(lazy(() => import("../pages/Comments")));
export const CommentsNew = Loadable(lazy(() => import("../pages/Comments/CommentsNew")));
export const CommentsEditPage = Loadable(lazy(() => import("../pages/Comments/CommentsEditPage")));

// COMMISION CALCULATION
export const CommissionCalculation = Loadable(lazy(() => import('../pages/CommissionCalculation')))
export const CalculationOfIncomeForStationPage = Loadable(lazy(() => import("../pages/CalculationOfIncomeForStation")));

// SETTINGS
export const SettingsPage = Loadable(lazy(() => import("../pages/Settings")));

// NOTIFICATIONS
export const NotificationsPage = Loadable(lazy(() => import("../pages/Notifications")));

// PREVIEW
export const PreviewTimes = Loadable(lazy(() => import("../pages/OperatorPreview/PreviewTimes")));
export const CommentsListPreviewPage = Loadable(lazy(() => import("../pages/OperatorPreview/PreviewCommentsList")));
//export const AllotmentListPreviewPage = Loadable(lazy(() => import("../pages/OperatorPreview/PreviewAllotmentList")));
export const CurrentAllotmentListPreviewPage = Loadable(lazy(() => import("../pages/OperatorPreview/PreviewCurrentAllotments")));
export const PreviewDeparturesLinked = Loadable(lazy(() => import("../pages/OperatorPreview/PreviewDeparturesLinked")));
export const PreviewCancelledTripsHistory = Loadable(lazy(() => import("../pages/OperatorPreview/PreviewCancelledTripsHistory")));
export const PreviewRatesHistory = Loadable(lazy(() => import("../pages/OperatorPreview/PreviewRatesHistory")));
export const PreviewTripExceptionHistory = Loadable(lazy(() => import("../pages/OperatorPreview/PreviewTripExceptionHistory")));
export const DeparturesStatus = Loadable(lazy(() => import("../pages/DepartureStatus")));
export const PeronizationStatus = Loadable(lazy(() => import("../pages/PeronizationStatus")));

// SERVICES REPORT
export const SoldServicesReport = Loadable(lazy(() => import("../pages/ServicesReport/SoldServicesReport")));


//ADMIN
export const UserPathPrivilegesPage = Loadable(lazy(() => import("../pages/Admin/UserPathPrivileges")));
export const TripAvailabilityCheckPage = Loadable(lazy(() => import("../pages/Admin/TripAvailabilityCheck")));
export const AdminStatisticsPage = Loadable(lazy(() => import("../pages/Admin/Statistics")));


//ADMIN
export const BarriersPage = Loadable(lazy(() => import("../pages/Barriers")));
export const BarriersNewPage = Loadable(lazy(() => import("../pages/Barriers/NewBarrierCard")));
export const BarriersExternalPartnersPage = Loadable(lazy(() => import("../pages/Barriers/ExternalPartners")));

export const ProjectImprovementsPage = Loadable(lazy(() => import("../pages/ProjectImprovements/ProjectProblems")));
export const ProjectUpdateDetail = Loadable(lazy(() => import("../pages/ProjectImprovements/ProjectUpdateDetail")));
export const ProjectBugNew = Loadable(lazy(() => import("../pages/ProjectImprovements/ProjectBugNew")));
export const ProjectUpdatesPage = Loadable(lazy(() => import("../pages/ProjectImprovements/ProjectUpdates")));
export const ProjectRequestsPage = Loadable(lazy(() => import("../pages/ProjectImprovements/ProjectRequests")));

// STATION LINE ASSIGNMENT
export const StationLineAssignmentPage = Loadable(lazy(() => import("../pages/StationLineAssignment/StationLineAssignmentList")));
